import React, {Component, Fragment} from 'react';
import Grid from "@material-ui/core/Grid";
import {SearchOutlined, ChromeReaderMode, HowToVoteOutlined, HdrStrongOutlined, HomeWork} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import {FieldsJs} from '../../../../../settings/General/General';
import Fab from "@material-ui/core/Fab";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";


class FiltrosCertificados extends Component {
	
	state = {};
	
	constructor() {
		super();
		this.state = {
			rfc: '',
			empresa: '',
			certificado: '',
			estatus: '',
			activo: '',
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
		setTimeout(() => this.HandleFiltro());
	};
	
	HandleFiltro = () => {
		let filtro = {};

		filtro.rfc = this.state.rfc || undefined;
		filtro.empresa = this.state.empresa || undefined;
		filtro.certificado = this.state.certificado || undefined;
		filtro.estatus = this.state.estatus || undefined;
		filtro.activo = this.state.activo || undefined;
		
		this.props.HandleFiltro(filtro);
	};
	
	AplicarFiltro = () => {
		this.props.AplicarFiltros();
	};
	
	render() {
		return (
			<Fragment>
				<Grid container spacing={2} alignContent={"flex-end"} alignItems={"flex-end"}>
					
					<Grid item xs={6} sm={6} md={2} lg={2} xl={2} align={'left'}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<ChromeReaderMode className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="rfc"
									onChange={this.handleChange}
									label="RFC"
									autoComplete={'off'}
									value={this.state.rfc}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item xs={6} sm={6} md={4} lg={4} xl={4} align={'left'}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HomeWork className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="empresa"
									onChange={this.handleChange}
									label="Razón Social"
									autoComplete={'off'}
									value={this.state.empresa}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HowToVoteOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<FormControl fullWidth>
								
								<InputLabel>Certificado</InputLabel>
								<Select
									native
									value={this.state.certificado}
									onChange={this.handleChange}
									name="certificado"
									input={<Input/>}
									disabled={this.state.tipo === 'view'}
								>
									<option value=""/>
									<option key={'1'} value={'1'}>eFirma (FIEL)</option>
									<option key={'2'} value={'2'}>CSD</option>
								</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HdrStrongOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<FormControl fullWidth>
								
								<InputLabel>Estatus</InputLabel>
								<Select
									native
									value={this.state.estatus}
									onChange={this.handleChange}
									name="estatus"
									input={<Input/>}
									disabled={this.state.tipo === 'view'}
								>
									<option value=""/>
									<option key={'1'} value={'1'}>Vigente</option>
									<option key={'2'} value={'2'}>Caduco</option>
								</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Grid>
					
					{/*<Grid item xs={6} sm={6} md={6} lg={2} xl={2} align={'left'}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<ScatterPlot className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="estatus"
									onChange={this.handleChange}
									label="Estatus"
									autoComplete={'off'}
									value={this.state.estatus}
								/>
							</Grid>
						</Grid>
					</Grid>*/}
					
					<Grid item xs={12} sm={12} md={12} lg={2} xl={2} align={'right'}>
						<Fab variant="extended" size="small" color="default" aria-label="Add"
						     onClick={this.AplicarFiltro}>
							<SearchOutlined className={'margin-5-R px-14'}/> Buscar
						</Fab>
					</Grid>
				
				</Grid>
			</Fragment>
		);
	}
}

FiltrosCertificados.propTypes = {
	HandleFiltro: PropTypes.func.isRequired,
	AplicarFiltros: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default FiltrosCertificados;
